(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/helpers.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo;
const productIds = svs.utils.products.productIds;
const SystemTypes = Object.freeze({
  MSYS: 'MSYS',
  SROW: 'SROW',
  RSYS: 'RSYS',
  USYS: 'USYS'
});
const QuickpickProps = Object.freeze({
  WEIGHTEDQP: 'WEIGHTEDQP',
  MODIFIEDQP: 'MODIFIEDQP',
  NOQP: 'no-qp',
  PARTIALQP: 'PARTIALQP',
  XPERTEN: 'XPERTEN'
});

function is1X2(productId) {
  switch (productId) {
    case productIds.CHALLENGE:
    case productIds.STRYKTIPSET:
    case productIds.EUROPATIPSET:
    case productIds.POWERPLAY:
    case productIds.T8STRYK:
    case productIds.T8EXTRA:
    case productIds.T8:
      return true;
    default:
      return false;
  }
}

function useAsyncSafeState(initValue) {
  const _useState = useState(initValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const isMountedRef = useRef(true);
  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);
  const asyncSafeSetValue = useCallback(data => {
    if (isMountedRef.current) {
      setValue(data);
    }
  }, []);
  return useMemo(() => [value, asyncSafeSetValue], [value, asyncSafeSetValue]);
}

const getNumberOfRows = (systemCost, rowPrice) => systemCost / (rowPrice || 1);
setGlobal('svs.components.sport.quickplayModal.helpers', {
  getNumberOfRows,
  is1X2,
  useAsyncSafeState,
  SystemTypes,
  QuickpickProps
});

 })(window);